import React, {PropTypes, Component } from 'react';
import renderHTML from 'react-render-html';
import CityCredits from './CityCredits';
import Intro from './Intro';
import moment from 'moment-timezone';
import {getCityBySlug} from "./cities/Cities";;
import { Link } from 'react-router-dom';

const PUZZLE_ZIP = "http://playdash.org/DASH9/DASH9-puzzles.zip";
const TITLE = "DASH 9 Puzzles";
const TEXT = `DASH 9 puzzles are available as a single download at <a href=${PUZZLE_ZIP}>DASH9-puzzles.zip</a>`

class Puzzles extends Component {
  render() {
    return (
        <div>
          <Intro title={TITLE} text={TEXT} />
          <div className="global indent">
            <article className="col-lg-12 col-md-12 col-sm-12 bookstoreBox">
              <h2><span className="credits-header">Puzzle Materials</span></h2>
              <article className="col-lg-3 col-md-6 col-sm-3 who-box" ></article>
              <article className="col-lg-6 col-md-6 col-sm-6 align-self-center who-box" >
              The following instructions explain the contents of <a href={PUZZLE_ZIP}>DASH9-puzzles.zip</a>, and how to make use of those contents.

              </article>
            </article>
            <div className="container">
              <div className="row justify-content-center">
                <article className="col-lg-3 col-md-6 col-sm-3 who-box" ></article>
                <article className="col-lg-6 col-md-6 col-sm-6 align-self-center who-box" >
                  <h2><span className="credits-header">Puzzles-Standard, Puzzles-Expert</span></h2>
                  <p>
                    Select a version to play:
                  </p>
                    <ul>
                      <li><strong>Standard</strong> - This level is a good choice for both novice and casual solvers (even if you have played DASH before).</li>
                      <li><strong>Expert</strong> - This level is more challenging because there are many places where puzzles do not have explicit instructions for solving. Instead, you need to infer the rules by examining the puzzle or detecting clues within each puzzle’s text; part of the challenge is to figure that out! In addition, some of the puzzles will be harder in the Expert version.</li>
                    </ul>
                  <p>
                    Please ensure that you do not scale the pages when printing. Depending on your software, you may need to specify “Actual Size” or select “None” for page scaling; do not choose an option to “fit” or “shrink” to printable area. This is critical for puzzle 6 since the transparency needs to match the other pages.
                  </p>
                </article>
              </div>
              <div className="row">
                <article className="col-lg-3 col-md-6 col-sm-3 who-box" ></article>
                <article className="col-lg-6 col-md-6 col-sm-6 who-box">
                  <h2><span className="credits-header">Transparency</span></h2>
                  <p>
                    This is puzzle 6 page 3 (for both versions) and needs to be on transparent material. FedEx Office Print & Ship Center is a good place to have this printed.
                  </p>
                </article>
              </div>
              <div className="row">
                <article className="col-lg-3 col-md-6 col-sm-3 who-box" ></article>
                <article className="col-lg-6 col-md-6 col-sm-6 who-box" >
                  <h2><span className="credits-header">Artifacts</span></h2>
                    <p>This file contains images for two puzzles: the six pentagons are used in puzzle 2; the three rhombi are for puzzle 7. These shapes were laser cut from thick board for the event.</p>
                    <p>You can print these pages for a simple version. It’s fine to make straight cuts along the sides; you don’t need to cut all the little in- and out-tabs. If you have cardstock available, printing on that so you have something a little sturdier than paper would be great, but it’s not required.</p>
                    <p>This file can also be used to laser etch and cut, but be aware that the results will vary based on the material and even possibly depending on the laser cutter. The material we used was <a href="http://www.dickblick.com/items/13004-1006/">28 ply (0.09") Crescent White Mounting Board</a> from Dick Blick Art Materials . Laser etching / cutting was done by <a href="https://www.pololu.com/product/749">Pololu Robotics & Electronics</a>.</p>
                </article>
              </div>
            </div>
            <article className="col-lg-12 col-md-12 col-sm-12 bookstoreBox">
              <h2><span className="credits-header">Playing The Hunt</span></h2>
            </article>
            <div className="container">
              <div className="row">
                <article className="col-lg-3 col-md-6 col-sm-3 who-box" ></article>
                <article className="col-lg-6 col-md-6 col-sm-6 who-box" >
                  <h2><span className="credits-header">Instructions</span></h2>
                  <p>
                  For DASH 9, many of the puzzles reference portions of previous puzzles. This means that you should keep all your puzzle materials in a safe place for the duration of the hunt.
                  </p>
                  <p>
                  <strong>Note:</strong> Because some of the puzzles rely on information from other puzzles, you may not be able to solve a single puzzle out of sequence.
                  </p>
                </article>
              </div>
              <div className="row">
                <article className="col-lg-3 col-md-6 col-sm-3 who-box" ></article>
                <article className="col-lg-6 col-md-6 col-sm-6 who-box" >
                  <h2><span className="credits-header">Page Counts</span></h2>
                  <p>
                  The materials you should have for each puzzle:
                  </p>
                  <ul>
                    <li><strong>Puzzle 1</strong>: 4 pages</li>
                    <li><strong>Puzzle 2</strong>: 5 pages, 6 pentagons</li>
                    <li><strong>Puzzle 3</strong>: 3 pages</li>
                    <li><strong>Puzzle 4</strong>: 2 pages</li>
                    <li><strong>Puzzle 5</strong>: 5 pages</li>
                    <li><strong>Puzzle 6</strong>: 4 pages (including transparency)</li>
                    <li><strong>Puzzle 7</strong>: 2 pages, 3 rhombi</li>
                    <li><strong>Puzzle 8</strong>: 3 pages</li>
                    <li><strong>Puzzle 9</strong>: 2 pages</li>
                  </ul>
                </article>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default Puzzles;



// WEBPACK FOOTER //
// ./src/Puzzles.js